import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Dropdown, Input, StateConfigContext, Typography, getTestId } from '@airtel/air-design-system';
import { useContext } from 'react';
import { getSkycFormWidgetStyles } from '../../../../SkycFormWidgetStyles';
import { getIdentityProofStyles, getIsDisabledState } from '../../IdentityProofUtils';
import { FileUploadSection } from '../file-upload-section';
export var ProofSection = props => {
  var dropdownProps = props.dropdownProps,
    inputProps = props.inputProps,
    proofType = props.proofType,
    showFrontUploadFiles = props.showFrontUploadFiles,
    showBackUploadFiles = props.showBackUploadFiles,
    frontFileUpload = props.frontFileUpload,
    backFileUpload = props.backFileUpload,
    handleDropdownChange = props.handleDropdownChange,
    handleTextChange = props.handleTextChange,
    handleProofOnPressIn = props.handleProofOnPressIn,
    handleOnValidInputMetaData = props.handleOnValidInputMetaData,
    uploadFrontFileProof = props.uploadFrontFileProof,
    uploadBackFileProof = props.uploadBackFileProof,
    handleFileUpload = props.handleFileUpload,
    handleDeleteIconPress = props.handleDeleteIconPress,
    testID = props.testID,
    variant = props.variant,
    uploadDataText = props.uploadDataText,
    isDisabledState = props.isDisabledState,
    idProofNumber = props.idProofNumber,
    onUserAction = props.onUserAction,
    _handleActionCtaPress = props.handleActionCtaPress;
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var skycFormWidgetStyle = getSkycFormWidgetStyles();
  var identityProofWidgetStyle = getIdentityProofStyles();
  return _jsxs(_Fragment, {
    children: [_jsx(Dropdown, Object.assign({}, dropdownProps, {
      theme: theme,
      inputContainerStyle: identityProofWidgetStyle.dropdownStyles,
      style: identityProofWidgetStyle.dropdownMenuItemStyles,
      position: "below",
      listMaxHeightPercentage: 30,
      onSelectedHandler: function onSelectedHandler() {
        for (var _len = arguments.length, value = new Array(_len), _key = 0; _key < _len; _key++) {
          value[_key] = arguments[_key];
        }
        return handleDropdownChange(value, proofType);
      }
    }, getTestId(testID, variant + "_" + proofType + "Dropdown"))), _jsx(Input, Object.assign({}, inputProps, {
      theme: theme,
      isDisabled: getIsDisabledState(isDisabledState, inputProps === null || inputProps === void 0 ? void 0 : inputProps.isDisabled),
      onChangeText: value => handleTextChange(value, proofType),
      containerStyle: skycFormWidgetStyle.inputWidget,
      readOnlyOnPress: () => handleProofOnPressIn(proofType),
      onValidInput: () => handleOnValidInputMetaData(proofType),
      style: identityProofWidgetStyle.inputStyles,
      value: proofType === 'identity' ? idProofNumber : undefined
    }, getTestId(testID, variant + "_" + proofType + "Input"))), _jsx(Typography, Object.assign({
      text: uploadDataText,
      type: "body-single-line-xs"
    }, getTestId(testID, variant + "_" + proofType + "Typography"), {
      style: identityProofWidgetStyle.typography
    })), _jsx(FileUploadSection, {
      type: proofType + "Front",
      showFiles: showFrontUploadFiles,
      fileUpload: frontFileUpload,
      uploadFileProof: uploadFrontFileProof,
      onUserAction: onUserAction,
      variant: variant,
      handleFileUpload: handleFileUpload,
      handleDeleteIconPress: handleDeleteIconPress,
      handleActionCtaPress: () => _handleActionCtaPress('front', proofType),
      testID: testID,
      style: identityProofWidgetStyle.uploadFileWidgetFront
    }, proofType + "Front"), _jsx(FileUploadSection, {
      type: proofType + "Back",
      showFiles: showBackUploadFiles,
      fileUpload: backFileUpload,
      uploadFileProof: uploadBackFileProof,
      variant: variant,
      handleFileUpload: handleFileUpload,
      handleDeleteIconPress: handleDeleteIconPress,
      testID: testID,
      onUserAction: onUserAction,
      handleActionCtaPress: () => _handleActionCtaPress('back', proofType)
    }, proofType + "Back")]
  });
};